module.exports = __webpack_public_path__ + "img/kv_6_2.b6687def.png";